export const pluralNounsNeutralFR: Array<string> = [
    'Actionnaires',
    'Activistes',
    'Adultes',
    'Adversaires',
    'Artistes',
    'Automobilistes',
    'Commissaires',
    'Comptables',
    'Concessionnaires',
    'Contribuables',
    'Dentistes',
    'Destinataires',
    'Diplomates',
    'Extraterrestres',
    'Fonctionnaires',
    'Gestionnaires',
    'Guides',
    'Homologues',
    'Journalistes',
    'Juges',
    'Jurys',
    'Locataires',
    'Maires',
    'Membres',
    'Mentors',
    'Ministres',
    'Modes',
    'Partenaires',
    'Peintres',
    'Philosophes',
    'Photographes',
    'Pilotes',
    'Pirates',
    'Postes',
    'Proches',
    'Psychologues',
    'Reporters',
    'Scientifiques',
    'Touristes',
    'Universitaires',
];
